export default function numberToGMT(hourOffset: number) {
  if (hourOffset === 0) {
    return 'GMT';
  } else {
    return `GMT${hourOffset > 0 ? '+' : ''}${hourOffset}`;
  }
}
